export default {
  "Credit Limit Request": "/limit-increase/pending",
  Order: "/orderlist",
};
